// CheckoutForm.js
import React from 'react';
import {injectStripe} from 'react-stripe-elements';

// import AddressSection from './AddressSection';
import CardSection from './cardSection';

class CheckoutForm extends React.Component {
  handleSubmit = (evt) => {
      evt.preventDefault();
      if (this.props.stripe) {
          this.props.stripe.createToken().then(this.props.handleResult);
      } else {
      }
  }
  render() {
    return (
      <div>
          <CardSection stripe={this.props.stripe}/>
      </div>
       
    );
  }
}

export default injectStripe(CheckoutForm);